import { memo } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
// Import Hooks
import useHasPermission from 'hooks/UseHasPermission';
// Import  Constants
import { l, ActionsIcons } from 'constants/common';
// Import UI Components
import { Button, Tooltip } from '@geneui/components';
// Import Enums
import { PermissionEnum } from 'enums';

const AdminSMSProviderActionsButtons = ({ data, editProviderAction, cloneProviderAction }) => {
    const { t } = useTranslation();
    const { hasPermission } = useHasPermission();
    const hasAdminPermission = hasPermission(PermissionEnum.CRMAdmin);

    if (isEmpty(data)) {
        return null;
    }

    return (
        <>
            {hasAdminPermission && (
                <Tooltip text={t(l.EditProvider)}>
                    <Button
                        flexibility="default"
                        icon={ActionsIcons.Edit}
                        appearance="minimal"
                        color="primary"
                        onClick={() => editProviderAction(data)}
                    />
                </Tooltip>
            )}
            <Tooltip text={t(l.CloneProvider)}>
                <Button
                    flexibility="default"
                    icon={ActionsIcons.Clone}
                    appearance="minimal"
                    color="primary"
                    onClick={() => cloneProviderAction(data)}
                />
            </Tooltip>
        </>
    );
};

AdminSMSProviderActionsButtons.propTypes = {
    data: PropTypes.object.isRequired,
    editProviderAction: PropTypes.func.isRequired,
    cloneProviderAction: PropTypes.func.isRequired,
};

export default memo(AdminSMSProviderActionsButtons);
